export default {
  placeholder: {
    en: 'Add friends’ email addresses',
  },
  buttonTitle: {
    en: 'Send',
  },
}
